import { withStyles } from "@material-ui/core";
import { createStyles, Theme } from "@material-ui/core/styles";
import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import * as settingService from "../services/settings";
import * as transactions from "../services/transactions";
import IOSTransaction from "./IOSTransaction";

const styles = (theme: Theme) => createStyles({});

interface IProps extends RouteComponentProps {
  transactionId: string;
  socket: Promise<SocketIOClient.Socket>;
}

interface IState {
  fetchedTransaction: boolean;
  id?: string;
  value?: number;
  bookingId?: string;
  currency?: string;
  os?: "Android" | "iOS";
  clientId?: string;
  socket: SocketIOClient.Socket | undefined;
}

class Transaction extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { fetchedTransaction: false, socket: undefined };
  }

  public async componentDidMount() {
    const transaction = await transactions.getTransactionDetails(this.props.transactionId);

    if (!transaction) {
      return;
    }

    const { os, clientId } = settingService.getSettings()!;

    this.setState({
      os,
      clientId,
      fetchedTransaction: true,
      socket: await this.props.socket,
      ...transaction
    });
  }

  public render() {
    if (this.state.os && this.state.fetchedTransaction) {
      switch (this.state.os) {
        case "Android":
          throw new Error("Android transactions not yet implemented.");
        case "iOS":
          // Disconnect on iOS
          this.state.socket!.disconnect();
          return (
            <IOSTransaction
              id={this.props.transactionId}
              value={this.state.value!}
              bookingId={this.state.bookingId!}
              callbackUrl={`https://${window.location.hostname}/transaction-result`}
              clientId={this.state.clientId!}
              currencyCode={this.state.currency!}
            />
          );
        default:
          throw Error(`'${this.state.os}' is not a recoginzed os.`);
      }
    }

    return (
      <div>
        Fetching transaction {this.props.transactionId}
        ...
      </div>
    );
  }
}

// class Transaction extends React.Component<any, any> {
//   constructor(props: any) {
//     super(props);
//     this.state = { ...props };

//     console.log("PROPS", ...props);
//   }

//   public render() {
//     const appUrl = [
//       "intent:#Intent;",
//       "action=com.squareup.pos.action.CHARGE;",
//       "package=com.squareup;",
//       "S.browser_fallback_url=https://www.google.com;",
//       `S.com.squareup.pos.WEB_CALLBACK_URI=https://dcabaada.au.ngrok.io/transaction-result;`,
//       "S.com.squareup.pos.CLIENT_ID=sq0idp-Dzrt1dKBDtf1hOkHmanjGA;",
//       "S.com.squareup.pos.API_VERSION=v2.0;",
//       `i.com.squareup.pos.TOTAL_AMOUNT=${this.props.value};`,
//       "S.com.squareup.pos.CURRENCY_CODE=AUD;",
//       "S.com.squareup.pos.TENDER_TYPES=com.squareup.pos.TENDER_CARD;",
//       "end"
//     ].join("");

//     return (
//       <a style={{ fontSize: "50pt" }} href={appUrl}>
//         Start Transaction for booking #{this.props.transaction.bookingId} $
//         {this.props.transaction.value} cents
//       </a>
//     );
//   }
// }

export default withStyles(styles)(Transaction);



// WEBPACK FOOTER //
// ./src/components/Transaction.tsx